"use client"
import { Button } from "@opensea/next-ui-kit"
import { useShallow } from "zustand/react/shallow"
import { Sound, usePlaySound } from "@/hooks/use-play-sound"
import { getVolumeIcon, useVolumeStore } from "@/stores/use-volume-store"

export function PageFooterVolumeToggle() {
  const { volume, toggleVolume } = useVolumeStore(
    useShallow(state => ({
      volume: state.volume,
      toggleVolume: state.toggleVolume,
    })),
  )
  const [playSelect] = usePlaySound(Sound.Select)
  const IconComponent = getVolumeIcon(volume)

  return (
    <Button
      className="size-5 p-0"
      onClick={() => {
        toggleVolume()
        playSelect()
      }}
      size="xs"
      value={volume}
      variant="ghost"
    >
      <IconComponent fill="interactive-secondary-styles" />
    </Button>
  )
}
